import { render } from 'react-dom'
import routes from 'common/routes.jsx'
//Bugsnag
Bugsnag.apiKey = 'f0cd61cb3ad78f85b48eaf5b9db76cd4'
Bugsnag.autoNotify = true
Bugsnag.releaseStage = __DEV ? 'development' : 'production'
Bugsnag.notifyReleaseStages = ['development', 'production']
Bugsnag.enableNotifyUnhandledRejections()
Bugsnag.notifyHandler = 'xhr'

const allRoutes = routes(JSON.parse(window.__DEFAULT_STATE))
render(allRoutes, document.getElementById('app'))
document.querySelector('[default-store]').remove()


// WEBPACK FOOTER //
// ./src/client/client.js